import React, { useState } from "react";
import {
  Container,
  Breadcrumb,
  Row,
  Col,
  Card,
  Button,
  Modal,
} from "react-bootstrap";
import { API_URL } from "../redux/config";
import axios from "axios";
import { useForm } from "react-hook-form";
import banner from "../assets/images/contact_us.png";
import bannermobile from "../assets/images/contact-us-mobile.jpg";
import aboutBannerLogo from "../assets/images/barndlogo.png";
import contact_icon from "../assets/images/contact_icon.png";
import media from "../assets/images/media.png";
import hr from "../assets/images/hr.png";
import shareholder from "../assets/images/shareholder.png";
import partner from "../assets/images/partner.png";
import clogo01 from "../assets/images/contact-brands/SAARTHI.png";
import clogo02 from "../assets/images/contact-brands/NAVGATI.png";
import clogo03 from "../assets/images/contact-brands/UNNATI.png";
// import clogo04 from "../assets/images/clogo04.png";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const ContactUs = ({ data }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    const {
      district,
      email,
      full_name,
      message,
      phone_number,
      pin_code,
      product_details,
      products,
      state,
    } = data;

    axios
      .post(API_URL + "ContactFormSubmit", {
        full_name: full_name,
        email: email,
        phone_number: phone_number,
        state: state,
        district: district,
        pin_code: pin_code,
        products: products,
        product_details: product_details,
        message: message,
      })
      .then((response) => {
        if (response.status === 200) {
          handleShow();
          reset();
        } else {
          //Something went wrong!
        }
      });
  };
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Nuvoco",
    image: "https://nuvoco.com/static/media/logo.4ea493e1b272e146e560.png",
    "@id": "https://nuvoco.com/",
    url: "https://nuvoco.com/",
    telephone: "+91 (0) 22 6769 2500",
    priceRange: "0",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Equinox Business Park, Tower-3, East Wing, 4th floor, Off Bandra-Kurla Complex, LBS Marg, Kurla (West)",
      addressLocality: "Mumbai",
      postalCode: "400 070",
      addressCountry: "IN",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 19.1284994,
      longitude: 72.9252816,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:30",
      closes: "18:30",
    },
  };
  return (
    <div className="contact_inner">
      <Helmet>
        <title>{t("SEO.contactus.title")}</title>
        <meta name="keywords" description="" />
        <meta
          name="description"
          content={t("SEO.contactus.desc")}
        />
        <link
          rel="canonical"
          href={window.location.origin + window.location.pathname}
        />
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
      </Helmet>
      <div className="banner text-center position-relative">
        <img className="desktopbannerinner" src={banner} alt="" />
        <img className="mobilebannerinner" src={bannermobile} alt="" />
        <article className="position-absolute text-center">
          <span className="d-flex justify-content-center align-items-center mx-auto">
            <img src={aboutBannerLogo} alt="" />
          </span>
          <h1 className="text-uppercase">{t("contact.title")}</h1>
        </article>
        <div className="breadouter">
          <div className="container">
            <Breadcrumb className="mb-0 py-2">
              <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
              <Breadcrumb.Item active>{t("contact.title")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <div className="card_round pt-5">
        <Container>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form_sce">
              <Row>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.Full_name")}*</label>
                    <input
                      type="text"
                      {...register("full_name", { required: true })}
                      placeholder={t("contact.Full_name")}
                      className="form-control name"
                    ></input>
                    <span className="error">
                      {errors["full_name"] &&
                        errors["full_name"].type === "required" &&
                        "Required*"}
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.Email_id")}*</label>
                    <input
                      type="text"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      })}
                      placeholder={t("contact.Email_id")}
                      className="form-control email"
                    ></input>
                    <span className="error">
                      {errors["email"] &&
                        errors["email"].type === "required" &&
                        "Required*"}
                    </span>
                    <span className="error">
                      {errors["email"] &&
                        errors["email"].type === "pattern" &&
                        "Invalid Email*"}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.Phone_Number")}*</label>
                    <input
                      type="number"
                      {...register("phone_number", {
                        required: true,
                        maxLength: 10,
                        minLength: 10,
                      })}
                      placeholder={t("contact.Phone_Number")}
                      className="form-control phone"
                    ></input>
                    <span className="error">
                      {errors["phone_number"] &&
                        errors["phone_number"].type === "required" &&
                        "Required*"}
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="form-group select_b">
                    <label>{t("contact.State")}*</label>

                    <select
                      className="form-control state"
                      {...register("state")}
                    >
                      <option value="Andhra Pradesh">Andhra Pradesh</option>
                      <option value="Andaman and Nicobar Islands">
                        Andaman and Nicobar Islands
                      </option>
                      <option value="Arunachal Pradesh">
                        Arunachal Pradesh
                      </option>
                      <option value="Assam">Assam</option>
                      <option value="Bihar">Bihar</option>
                      <option value="Chandigarh">Chandigarh</option>
                      <option value="Chhattisgarh">Chhattisgarh</option>
                      <option value="Dadar and Nagar Haveli">
                        Dadar and Nagar Haveli
                      </option>
                      <option value="Daman and Diu">Daman and Diu</option>
                      <option value="Delhi">Delhi</option>
                      <option value="Lakshadweep">Lakshadweep</option>
                      <option value="Puducherry">Puducherry</option>
                      <option value="Goa">Goa</option>
                      <option value="Gujarat">Gujarat</option>
                      <option value="Haryana">Haryana</option>
                      <option value="Himachal Pradesh">Himachal Pradesh</option>
                      <option value="Jammu and Kashmir">
                        Jammu and Kashmir
                      </option>
                      <option value="Jharkhand">Jharkhand</option>
                      <option value="Karnataka">Karnataka</option>
                      <option value="Kerala">Kerala</option>
                      <option value="Madhya Pradesh">Madhya Pradesh</option>
                      <option value="Maharashtra">Maharashtra</option>
                      <option value="Manipur">Manipur</option>
                      <option value="Meghalaya">Meghalaya</option>
                      <option value="Mizoram">Mizoram</option>
                      <option value="Nagaland">Nagaland</option>
                      <option value="Odisha">Odisha</option>
                      <option value="Punjab">Punjab</option>
                      <option value="Rajasthan">Rajasthan</option>
                      <option value="Sikkim">Sikkim</option>
                      <option value="Tamil Nadu">Tamil Nadu</option>
                      <option value="Telangana">Telangana</option>
                      <option value="Tripura">Tripura</option>
                      <option value="Uttar Pradesh">Uttar Pradesh</option>
                      <option value="Uttarakhand">Uttarakhand</option>
                      <option value="West Bengal">West Bengal</option>
                    </select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.District")}*</label>
                    <input
                      type="text"
                      {...register("district", { required: true })}
                      placeholder={t("contact.District")}
                      className="form-control state"
                    ></input>
                    <span className="error">
                      {errors["district"] &&
                        errors["district"].type === "required" &&
                        "Required*"}
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.Pincode")}*</label>
                    <input
                      type="number"
                      {...register("pin_code", { required: true })}
                      placeholder={t("contact.Pincode")}
                      className="form-control pincode"
                    ></input>
                    <span className="error">
                      {errors["pin_code"] &&
                        errors["pin_code"].type === "required" &&
                        "Required*"}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group select_b">
                    <label>{t("contact.Portfolio")}*</label>
                    <select
                      className="form-control cementIcon"
                      {...register("products")}
                    >
                      <option value="Cement">Cement</option>
                      <option value="Concrete">Concrete</option>
                      <option value="MBM">MBM</option>
                      <option value="Corporate">Corporate</option>
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group select_b">
                    <label>{t("contact.Product_details")}*</label>
                    <select
                      className="form-control cementIcon"
                      {...register("product_details")}
                    >
                      <option value="Purchase">Purchase</option>
                      <option value="Dealership">Dealership</option>
                      <option value="CFA">CFA</option>
                      <option value="Non Trade">Non Trade</option>
                      <option value="Business Proposal">
                        Business Proposal
                      </option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>{t("contact.Message")}*</label>
                    <textarea
                      type="text"
                      {...register("message")}
                      row="8"
                      placeholder="Message"
                      className="form-control message"
                    ></textarea>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="text-center">
              <Button variant="success" className="read_more" type="submit">
                {t("contact.Submit")}{" "}
              </Button>
            </div>
          </form>

          <div className="ct_nuvoco card_round">
            <Card className="ct_01">
              <div className="card_header">
                <img src={contact_icon} alt="contact" />
                {t("contact.nvcl.title")}
              </div>
              <div className="in"></div>
              <Card.Body>
                <p>{t("contact.nvcl.reg")}</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("contact.nvcl.address"),
                  }}
                ></p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("contact.nvcl.contact"),
                  }}
                ></p>
                <p
                  dangerouslySetInnerHTML={{ __html: t("contact.nvcl.email") }}
                ></p>
                <p
                  dangerouslySetInnerHTML={{ __html: t("contact.nvcl.CIN") }}
                ></p>
              </Card.Body>
            </Card>

            <Card className="ct_01">
              <div className="card_header">
                <img src={contact_icon} alt="" /> {t("contact.nuVista.title")}
              </div>
              <div className="in"></div>
              <Row>
                <Col md={6}>
                  <Card.Body>
                    <p>{t("contact.nuVista.reg.title")}</p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.nuVista.reg.address"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.nuVista.reg.contact"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.nuVista.reg.CIN"),
                      }}
                    ></p>
                  </Card.Body>
                </Col>
                <Col md={6} className="mm_z">
                  <Card.Body>
                    <p>{t("contact.nuVista.corp.title")}</p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.nuVista.corp.address"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.nuVista.corp.contact"),
                      }}
                    ></p>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
            <Card className="ct_01">
              <div className="card_header">
                <img src={contact_icon} alt="" />{" "}
                {t("contact.vadrajCement.title")}
              </div>
              <div className="in"></div>
              <Row className="justify-content-center">
                <Col md={6}>
                  <Card.Body>
                    <p>{t("contact.nuVista.reg.title")}</p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.vadrajCement.reg.address"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.vadrajCement.reg.contact"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.vadrajCement.reg.email"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("contact.vadrajCement.reg.CIN"),
                      }}
                    ></p>
                  </Card.Body>
                </Col>
              </Row>
            </Card>

            <Row className="ct_03">
              <Col md={6}>
                <Card>
                  <div className="card_header">
                    <img src={media} alt="media" /> {t("contact.media.title")}
                  </div>
                  <div className="in"></div>
                  <Card.Body>
                    <p>
                      <strong>{t("contact.contact")}:</strong>{" "}
                      <a href="tel:+912267692500">+91 (0) 22 6769 2500 </a>
                    </p>
                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:india.communications@nuvoco.com">
                        india.communications@nuvoco.com
                      </a>
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} className="mm_z">
                <Card>
                  <div className="card_header">
                    <img src={hr} alt="hr" /> {t("contact.hr.title")}
                  </div>
                  <div className="in"></div>
                  <Card.Body>
                    <p>
                      <strong>{t("contact.contact")}:</strong>{" "}
                      <a href="tel:+912267692500">+91 (0) 22 6769 2500</a>
                    </p>
                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:talent.acquisition@nuvoco.com">
                        talent.acquisition@nuvoco.com
                      </a>
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Card className="ct_04">
              <div className="card_header">
                <img src={shareholder} alt="shareholder" />{" "}
                {t("contact.shareholder_matters.title")}
              </div>
              <div className="in"></div>
              <Row>
                <Col>
                  <Card.Body>
                    <p>
                      {" "}
                      {t(
                        "contact.shareholder_matters.institute_investors.title"
                      )}{" "}
                    </p>
                    <p>
                      <strong>{t("contact.name")}:</strong>{" "}
                      {t(
                        "contact.shareholder_matters.institute_investors.name.value"
                      )}
                    </p>
                    <p>
                      <strong>{t("contact.contact")}:</strong>{" "}
                      <a href="tel:+912267692500">+91 (0) 22 6769 2500</a>
                    </p>
                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:investor.relations@nuvoco.com">
                        investor.relations@nuvoco.com
                      </a>
                    </p>
                  </Card.Body>
                </Col>
                <Col className="mm_z">
                  <Card.Body>
                    <p>
                      {t(
                        "contact.shareholder_matters.shares_dividends_compliances.title"
                      )}
                    </p>
                    <p>
                      <strong>{t("contact.name")}:</strong>{" "}
                      {t(
                        "contact.shareholder_matters.shares_dividends_compliances.name.value"
                      )}
                    </p>
                    <p>
                      <strong>{t("contact.contact")}:</strong>{" "}
                      <a href="tel:+912267692500">+91 (0) 22 6769 2500</a>
                    </p>
                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:investor.relations@nuvoco.com">
                        investor.relations@nuvoco.com
                      </a>
                    </p>
                  </Card.Body>
                </Col>
              </Row>

              <Row>
                <h3 className="headingstyle">
                  <b>
                    {t("contact.shareholder_matters.nuvoco_vistas_corp.title")}
                  </b>
                </h3>
                <Col>
                  <div className="address">
                    <Card.Body>
                      <p>
                        <b>
                          {t(
                            "contact.shareholder_matters.nuvoco_vistas_corp.debenture_trustee.title"
                          )}
                        </b>
                      </p>
                      <p>
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.debenture_trustee.subtitle"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.address")}: </strong>
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.debenture_trustee.address"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.contact")}:</strong>{" "}
                        <a href="tel:+912240807000">+91 (0) 22 4080 7000</a>
                      </p>

                      <p>
                        <strong>{t("contact.email")}:</strong>{" "}
                        <a href="mailto:itsl@idbitrustee.com">
                          itsl@idbitrustee.com
                        </a>
                      </p>
                      <p>
                        <a
                          className="text-decoration-none text-dark"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.google.com/maps/place/IDBI+Trusteeship+Services+Limited/@18.9350932,72.8371259,17z/data=!3m1!4b1!4m5!3m4!1s0x3be7d1da7c07a6fb:0xefb78989f2d08525!8m2!3d18.9351078!4d72.8392487"
                        >
                          <span className="border-bottom border-2 border-dark">
                            {t("contact.get_directions")}
                          </span>
                        </a>
                      </p>
                    </Card.Body>
                  </div>
                </Col>
                <Col>
                  <div className="address">
                    <Card.Body>
                      <p>
                        <b>
                          {t(
                            "contact.shareholder_matters.nuvoco_vistas_corp.registrar_and_transfer_agent.title"
                          )}
                        </b>
                      </p>
                      <p>
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.registrar_and_transfer_agent.subtitle"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.address")}: </strong>
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.registrar_and_transfer_agent.address"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.contact")}:</strong>{" "}
                        <a href="tel:+918108116767">+91 (0) 8108116767</a>
                      </p>
                      <p>
                        <strong>{t("contact.email")}: </strong>
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.registrar_and_transfer_agent.ncd"
                        )}{" "}
                        -{" "}
                        <a href="mailto:bonds.helpdesk@linkintime.co.in">
                          bonds.helpdesk@linkintime.co.in{" "}
                        </a>
                        <br />
                        {t(
                          "contact.shareholder_matters.nuvoco_vistas_corp.registrar_and_transfer_agent.share"
                        )}{" "}
                        -{" "}
                        <a href="mailto:rnt.helpdesk@linkintime.co.in">
                          rnt.helpdesk@linkintime.co.in
                        </a>
                      </p>
                      <p>
                        <strong>{t("contact.website")}:</strong>{" "}
                        <a target="_blank" rel="noreferrer" href="https://in.mpms.mufg.com/">
                          https://in.mpms.mufg.com/
                        </a>
                      </p>

                      <p>
                        <a
                          className="text-decoration-none text-dark"
                          target="_blank"
                          rel="noreferrer"
                          href="https://maps.app.goo.gl/dbwTxsvj9XMkJRyb7"
                        >
                          <span className="border-bottom border-2 border-dark">
                            {t("contact.get_directions")}
                          </span>
                        </a>
                      </p>
                    </Card.Body>
                  </div>
                </Col>
                {/* <Col>
<div className="address">
<Card.Body>
<p><b>Company Contact</b></p>
<p>Ms. Shruta Sanghavi - SVP and Company Secretary</p>
<p><strong>Address: </strong>Equinox Business Park, Tower-3, East Wing, 4th floor, Off Bandra-Kurla Complex, LBS Marg, Kurla (West), Mumbai 400 070</p>   
<p><strong>Contact:</strong> <a href="tel:+912267692500">+91 (0) 22 6769 2500</a></p>
<p><strong>Email:</strong><a href="mailto:investor.relations@nuvoco.com">investor.relations@nuvoco.com </a></p>

<p><a className="text-decoration-none text-dark" target="blank" href="https://www.google.com/maps/search/Equinox+Business+Park,+Ambedkar+Nagar,+Kurla+West,+Kurla,+Mumbai,+Maharashtra+400070/@19.0708782,72.8740444,17z/data=!3m1!4b1"><span className="border-bottom border-2 border-dark">Get Directions</span></a></p>
</Card.Body>
</div>
</Col> */}
              </Row>

              <Row>
                <h3 className="headingstyle">
                  <b>{t("contact.shareholder_matters.nu_vista_ltd.title")}</b>
                </h3>
                <Col>
                  <div className="address">
                    <Card.Body>
                      <p>
                        <b>
                          {t(
                            "contact.shareholder_matters.nu_vista_ltd.company_contact.title"
                          )}
                        </b>
                      </p>
                      <p>
                        {t(
                          "contact.shareholder_matters.nu_vista_ltd.company_contact.subtitle"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.address")}: </strong>
                        {t(
                          "contact.shareholder_matters.nu_vista_ltd.company_contact.address"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.contact")}:</strong>{" "}
                        <a href="tel:+912267692500">+91 (0) 6769 2500</a>
                      </p>

                      <p>
                        <strong>{t("contact.email")}:</strong>{" "}
                        <a href="mailto:secretarial.desk@nuvoco.com">
                          secretarial.desk@nuvoco.com
                        </a>
                      </p>
                      <p>
                        <a
                          className="text-decoration-none text-dark"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.google.com/maps/place/Equinox+Business+Park/@19.0705795,72.8742324,17z/data=!3m1!4b1!4m5!3m4!1s0x3be7c893209d27a1:0xbd8e525b6e6889!8m2!3d19.0705795!4d72.8764211"
                        >
                          <span className="border-bottom border-2 border-dark">
                            {t("contact.get_directions")}
                          </span>
                        </a>
                      </p>
                    </Card.Body>
                  </div>
                </Col>
                <Col>
                  <div className="address">
                    <Card.Body>
                      <p>
                        <b>
                          {t(
                            "contact.shareholder_matters.nu_vista_ltd.registrar_and_transfer_agent.title"
                          )}
                        </b>
                      </p>
                      <p>
                        {t(
                          "contact.shareholder_matters.nu_vista_ltd.registrar_and_transfer_agent.subtitle"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.address")}: </strong>
                        {t(
                          "contact.shareholder_matters.nu_vista_ltd.registrar_and_transfer_agent.address"
                        )}
                      </p>
                      <p>
                        <strong>{t("contact.contact")}:</strong>{" "}
                        <a href="tel:1800-309-4001">1800-309-4001</a>
                      </p>
                      <p>
                        <strong>{t("contact.email")}:</strong>{" "}
                        <a href="mailto:einward.ris@kfintech.com">
                          einward.ris@kfintech.com
                        </a>
                      </p>
                      <p>
                        <strong>{t("contact.website")}:</strong>{" "}
                        <a target="_blank" rel="noreferrer" href="https://www.kfintech.com">
                          www.kfintech.com
                        </a>
                      </p>

                      <p>
                        <a
                          className="text-decoration-none text-dark"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.google.com/maps/place/KFintech+Pvt+Ltd/@17.4213558,78.3309726,17z/data=!3m1!4b1!4m5!3m4!1s0x3bcb937dde7fafb3:0x3ab58aee0b12590f!8m2!3d17.4213802!4d78.3331771?shorturl=1"
                        >
                          <span className="border-bottom border-2 border-dark">
                            {t("contact.get_directions")}
                          </span>
                        </a>
                      </p>
                    </Card.Body>
                  </div>
                </Col>
              </Row>
            </Card>

            <Card className="ct_04">
              <div className="card_header">
                <img src={partner} alt="partner" /> {t("contact.partner_relations.title")}
              </div>
              <div className="in"></div>

              <Row>
                <Col md={12} style={{ marginTop: 100, marginBottom: -50 }}>
                  <p>{t("contact.partner_relations.heading")} </p>
                </Col>
                <Col md={4}>
                  <Card.Body>
                    <img src={clogo01} alt="" className="cicon" />

                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:helpdesk@nuvocosaarthi.com">
                        helpdesk@nuvocosaarthi.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.log_on_to")}: </strong>{" "}
                      <a href="https://nuvocosaarthi.com/" target="_blank" rel="noreferrer">
                        nuvocosaarthi.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.register_on")}: </strong>{" "}
                      <a
                        href="https://play.google.com/store/apps/details?id=lafarge.maitree.loyalty.lafarge"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Saarthi {t("contact.app")}
                      </a>
                    </p>
                  </Card.Body>
                </Col>
                <Col md={4}  >
                  <Card.Body>
                    <img src={clogo02} alt="" className="cicon" />

                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:helpdesk@nuvoconavgati.com">
                        helpdesk@nuvoconavgati.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.log_on_to")}: </strong>{" "}
                      <a href="https://nuvoconavgati.com/" target="_blank" rel="noreferrer">
                        nuvoconavgati.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.register_on")}: </strong>{" "}
                      <a
                        href="https://play.google.com/store/apps/details?id=com.mjunction.lafarge.milan"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Navgati {t("contact.app")}
                      </a>
                    </p>
                  </Card.Body>
                </Col>
                <Col md={4}>
                  <Card.Body  >
                    <img src={clogo03} alt="" className="cicon" />

                    <p>
                      <strong>{t("contact.email")}:</strong>{" "}
                      <a href="mailto:helpdesk@nuvocounnati.com">
                        helpdesk@nuvocounnati.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.log_on_to")}: </strong>{" "}
                      <a
                        href="https://nuvocounnati.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        nuvocounnati.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.register_on")}: </strong>{" "}
                      <a
                        href="https://play.google.com/store/apps/details?id=com.nuvoco.vriddhi"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Unnati {t("contact.app")}
                      </a>
                    </p>
                  </Card.Body>
                </Col>
                {/* <Col md={6}>
                  <Card.Body className="pt-1">
                    <img src={clogo04} alt="" />
                    <p>{t("contact.partner_relations.nipun")}</p>

                    <p>
                      <strong>{t("contact.log_on_to")}: </strong>{" "}
                      <a
                        href="https://www.nipun.doublebullcement.com/"
                        target="_blank"
                      >
                        nipun.doublebullcement.com
                      </a>
                    </p>
                    <p>
                      <strong>{t("contact.contact")}:</strong>{" "}
                      <a href="tel:18001212828" target="_blank">
                        {" "}
                        1800 121 2828
                      </a>
                    </p>
                  </Card.Body>
                </Col> */}
              </Row>
              <p>
                <div dangerouslySetInnerHTML={{ __html: t('SEO.contactus.help') }} />

                {/* <strong>{t("contact.contact")}:</strong>{" "}
                <a href="tel:18004199098">1800 419 9098</a> (
                {t("contact.toll_free")}) */}
              </p>
              {/* <p>
                <strong>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: t("contact.footer") }}
                  ></span>{" "}
                  - 1800 345 6666 ({t("contact.toll_free")})
                </strong>
              </p> */}
            </Card>
          </div>
          <br /><br />
        </Container>
      </div>
      <Modal className="success_mb" show={show} onHide={handleClose}>
        <Modal.Body>
          <h5>Thank you. We have received your details</h5>
          <Button variant="success" onClick={handleClose}>
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ContactUs;
